import type { ConfiguredAddOn } from '../types/addon.types';

export type InstanceIdMinter = () => number;

const highestInstanceId = (lines: readonly Pick<ConfiguredAddOn, 'instanceId'>[]): number =>
    lines.reduce(
        (max, line) =>
            Number.isSafeInteger(line.instanceId) && line.instanceId > max ? line.instanceId : max,
        0
    );

// Every minted id exceeds every id in `existing`, so ids are unique within the list being extended.
export function instanceIdMinter(
    existing: readonly Pick<ConfiguredAddOn, 'instanceId'>[],
    now: number = Date.now()
): InstanceIdMinter {
    let next = Math.max(Math.trunc(now), highestInstanceId(existing) + 1, 1);
    return () => {
        if (!Number.isSafeInteger(next)) {
            throw new Error('Add-on instance id exceeds the safe integer range');
        }
        return next++;
    };
}
